// extracted by mini-css-extract-plugin
export var rateTable = "_51-0";